import MetaTags from 'components/meta/MetaTags'
import ScrollTop from 'components/utils/ScrollTop'
import HelpSection from 'components/display/HelpSection'
import HeaderSection from './HeaderSection'
import ConnectSection from './ConnectSection'
import CommunitySection from './CommunitySection'
import { SectionContainer } from './styles'

const Contact = () => {
  const openChat = () => {
    Intercom('show')
  }
  return (
    <>
      <MetaTags title="Contact" />

      <ScrollTop />

      <HeaderSection openChat={openChat} />

      <SectionContainer>
        <ConnectSection openChat={openChat} />
      </SectionContainer>

      <SectionContainer>
        <CommunitySection />
      </SectionContainer>

      <SectionContainer>
        <HelpSection alignment="flex-start" link="https://help.riparide.com/" />
      </SectionContainer>
    </>
  )
}

export default Contact
